// Lightweight toast notifications — exposes toastSuccess/toastError/toastInfo on window
(function() {
  if (window.__toastInitialized) return;
  window.__toastInitialized = true;

  const css = `
  .cd-toast-wrap { position: fixed; top: 18px; right: 18px; z-index: 99999; display: flex; flex-direction: column; gap: 8px; }
  .cd-toast { min-width: 220px; max-width: 420px; padding: 10px 14px; border-radius: 8px; color: #fff; box-shadow: 0 6px 18px rgba(2,6,23,0.3); font-weight: 600; font-size: 13px; display: flex; align-items: center; gap: 10px; }
  .cd-toast .cd-toast-close { margin-left: auto; cursor: pointer; opacity: 0.9; }
  .cd-toast--success { background: linear-gradient(90deg,#10b981,#059669); }
  .cd-toast--error   { background: linear-gradient(90deg,#ef4444,#b91c1c); }
  .cd-toast--info    { background: linear-gradient(90deg,#3b82f6,#2563eb); }
  `;

  const s = document.createElement('style'); s.appendChild(document.createTextNode(css)); document.head && document.head.appendChild(s);

  const wrap = document.createElement('div'); wrap.className = 'cd-toast-wrap'; document.body && document.body.appendChild(wrap);

  function make(text, type, timeout) {
    const el = document.createElement('div');
    el.className = 'cd-toast cd-toast--' + (type || 'info');
    el.innerHTML = '<div class="cd-toast-text">' + (text || '') + '</div><div class="cd-toast-close">×</div>';
    const close = () => { try { el.style.opacity = '0'; setTimeout(() => el.remove(), 260); } catch(e){} };
    el.querySelector('.cd-toast-close').addEventListener('click', close);
    wrap.appendChild(el);
    if (timeout !== 0) setTimeout(close, timeout || 4500);
    return el;
  }

  window.toastSuccess = function(text, timeout) { try { return make(text, 'success', timeout); } catch(e){} };
  window.toastError   = function(text, timeout) { try { return make(text, 'error', timeout); } catch(e){} };
  window.toastInfo    = function(text, timeout) { try { return make(text, 'info', timeout); } catch(e){} };
})();

export {};
